namespace $ {
	export class $mol_button_minor extends $mol_button_typed {
	}
	
}

